module.exports = __webpack_public_path__ + "assets/img/orderActive.03886c40.svg";